module.exports = __webpack_public_path__ + "ab2737e6443646f3ba2fb84c2f2e5643.svg";